enum TaskCompletionsFilterFieldNames {
  Period = 'period',
  Users = 'users',
  ValidityHints = 'validityHints',
}

export default TaskCompletionsFilterFieldNames;
